import React, { useState } from "react";
import { Field } from "redux-form";
import { email, required } from "redux-form-validators";

import { Button, Captcha, Checkbox } from "../../../components/Field";
import { scrollToTop } from "../../../helpers/animation";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer"
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import AsyncForm from "../../../components/AsyncForm";
import Background from "../../../components/Background";
import Input from "../../../components/Field/Input/Input";
import Textarea from "../../../components/Field/Input/Textarea";

import style from "./style.module.css";

export default function ContactUs(props) {
    const {
        bg_image = "",
        title = "",
        description = "",
        success_title = "",
        success_description = "",
    } = props;

    const [success, setSuccess] = useState(false);
    const setTitle = success === false ? title : success_title;
    const setDescription = success === false ? description : success_description;

    return (
        <div className={style.contactUs}>
            <div className={`${style.stepRow}`}>
                <div className={style.stepImage}>
                    <div className={style.stepImageWrap}>
                        <Background src={bg_image} size="1224x2220" cPosition="topLeft" />
                    </div>
                </div>
                <div className={style.stepText}>
                    <Section className={style.rightSection} center={false}>
                        <div className={style.rightSectionCenter}>
                            <div className={style.stepTextWrapper}>
                                <div className={style.stepInnerRow}>
                                    <div className={style.textContentHeader}>
                                        {
                                            setTitle !== "" && (
                                                <div className={`${style.title} ${success === true ? style.successTitle : ""}`}>
                                                    <Title className="fontTeko" transform="textUpperCase" tag="h3">{setTitle}</Title>
                                                </div>
                                            )
                                        }
                                        {
                                            success === true && (
                                                <div className={style.successMsg}>
                                                    <Editor text="Your message has been successfully sent." />
                                                    <Spacer size="24" />
                                                </div>
                                            )
                                        }
                                        {
                                            setDescription !== "" && (
                                                <div className={style.text}>
                                                    <Editor text={setDescription} />
                                                </div>
                                            )
                                        }
                                    </div>
                                    <Spacer size="24" />
                                    <div className={style.textContentBody}>
                                        {
                                            success === false && (
                                                <AsyncForm
                                                    url="/submit/contact"
                                                    permissionText={false}
                                                    showToastOnSuccess={false}
                                                    onSave={() => {
                                                        setSuccess(true);
                                                        scrollToTop();
                                                    }}
                                                    render={({ fetching, invalid }) => {
                                                        return (
                                                            <div className={style.form}>
                                                                <div className={style.formRow}>
                                                                    <Field
                                                                        name="first_name"
                                                                        component={Input}
                                                                        validate={required()}
                                                                        required={true}
                                                                        placeholder="Enter your first name"
                                                                        label="First name"
                                                                    />
                                                                </div>
                                                                <div className={style.formRow}>
                                                                    <Field
                                                                        name="last_name"
                                                                        component={Input}
                                                                        validate={required()}
                                                                        required={true}
                                                                        placeholder="Enter your last name"
                                                                        label="Last name"
                                                                    />
                                                                </div>
                                                                <div className={style.formRow}>
                                                                    <Field
                                                                        name="email"
                                                                        component={Input}
                                                                        validate={[required(), email()]}
                                                                        required={true}
                                                                        placeholder="Enter your email address"
                                                                        label="Email address"
                                                                    />
                                                                </div>
                                                                <div className={style.formRow}>
                                                                    <Field
                                                                        name="phone"
                                                                        component={Input}
                                                                        validate={[required()]}
                                                                        required={true}
                                                                        placeholder="Enter your phone number"
                                                                        label="Phone Number"
                                                                    />
                                                                </div>
                                                                <div className={style.formRow}>
                                                                    <Field
                                                                        placeholder="Leave your message here."
                                                                        name="message"
                                                                        component={Textarea}
                                                                        validate={required()}
                                                                        label="Enter your message"
                                                                        type="textarea"
                                                                        showcount={false}
                                                                    />
                                                                </div>
                                                                <div className={`${style.formRow} ${style.formHelpText}`}>
                                                                    <Editor text="Fields marked with an asterisk (*) are required." />
                                                                </div>
                                                                <div className={`${style.formRow} ${style.checkBoxHelpText}`}>
                                                                    <Field
                                                                        name="privacy"
                                                                        component={Checkbox}
                                                                        checkValue={1}
                                                                        validate={required()}
                                                                        link="/privacy-statement"
                                                                        label='By checking the box and clicking "Submit", you are agreeing to the WW2 HQ <i> Privacy Statement</i>'
                                                                    />
                                                                </div>
                                                                <div className={style.formRow}>
                                                                    <Field 
                                                                        name="captcha" 
                                                                        component={Captcha} 
                                                                        validate={required()} 
                                                                    />
                                                                </div>
                                                                <div className={`${style.formRow} ${style.formSubmit}`}>
                                                                    <Button
                                                                        disabled={invalid}
                                                                        color="buttonPrimary"
                                                                        submit={true}
                                                                        fetching={fetching}
                                                                        label="SUBMIT"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                />
                                            )
                                        }
                                        {
                                            success === true && (
                                                <div className={`${style.formRow} ${style.formSubmit}`}>
                                                    <Button
                                                        link="/"
                                                        color="buttonPrimary"
                                                        label="CONTINUE TO EXPLORE"
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Section>
                </div>
            </div>
        </div>
    )
}